export default __webpack_public_path__ + "static/media/autoconvert.d2e1202c.png";